<template>
  <div class="guide">
    <div class="card-guide-body">
      <div class="d-flex justify-content-between">
        <span class="search">
          <label>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.3335 3.16659C4.75617 3.16659 2.66683 5.25592 2.66683 7.83325C2.66683 10.4106 4.75617 12.4999 7.3335 12.4999C9.91083 12.4999 12.0002 10.4106 12.0002 7.83325C12.0002 5.25592 9.91083 3.16659 7.3335 3.16659ZM1.3335 7.83325C1.3335 4.51954 4.01979 1.83325 7.3335 1.83325C10.6472 1.83325 13.3335 4.51954 13.3335 7.83325C13.3335 11.147 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.147 1.3335 7.83325Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6284 11.1286C10.8887 10.8683 11.3108 10.8683 11.5712 11.1286L14.4712 14.0286C14.7315 14.289 14.7315 14.7111 14.4712 14.9714C14.2108 15.2318 13.7887 15.2318 13.5284 14.9714L10.6284 12.0714C10.368 11.8111 10.368 11.389 10.6284 11.1286Z"
                fill="#B3C2CB"
              />
            </svg>
            <input
              type="search"
              class="search-input"
              placeholder="Search FAQs"
              v-model="searchStr"
            /> </label
        ></span>
      </div>
      <div class="users" role="tablist">
        <b-card no-body>
          <b-table
            id="beta_users"
            :fields="fields"
            :items="users"
            striped
            small
            primary-key="a"
            show-empty
          >
            <template #table-busy>
              .. busy
            </template>
            <template #empty="scope">
              No Data Available
            </template>
            <!-- A custom formatted column -->
            <template #cell(auth)="row">
              <svg
                v-if="row.item._provider == 'email'"
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="29"
                viewBox="1 1 600 600"
              >
                <g transform="matrix(6.66667 0 0 6.66667 -5.667 -6408.081)">
                  <linearGradient
                    id="a"
                    gradientUnits="userSpaceOnUse"
                    x1="-110.934"
                    y1="1129.751"
                    x2="-110.35"
                    y2="1720.099"
                    gradientTransform="matrix(1 0 0 -1 156.89 2180.75)"
                  >
                    <stop offset="0" stop-color="#70efff" />
                    <stop offset="1" stop-color="#5770ff" />
                  </linearGradient>
                  <path
                    d="M21.653 961.362h48.695a20.608 20.608 0 0 1 20.653 20.653v48.695a20.608 20.608 0 0 1-20.653 20.653H21.653A20.608 20.608 0 0 1 1 1030.71v-48.695a20.608 20.608 0 0 1 20.653-20.653z"
                    fill="url(#a)"
                  />
                  <path
                    d="M20.719 986.956c-.474 0-.921.082-1.344.25l8.469 8.719 8.563 8.875.156.188.25.25.25.25.5.531 7.344 7.531c.122.076.477.404.754.543.357.178.743.343 1.141.357.43.015.869-.108 1.256-.296.29-.141.419-.343.755-.603l8.5-8.781 8.594-8.844 8.281-8.531a3.635 3.635 0 0 0-1.75-.438H20.719zm-2.594 1.062c-.903.856-1.469 2.142-1.469 3.594v28.625c0 1.175.377 2.243 1 3.062l1.187-1.125 8.844-8.594 7.844-7.594-.156-.187-8.594-8.844-8.594-8.875-.062-.062zm57.188.282l-8.375 8.656-8.563 8.844-.156.156 8.156 7.906 8.844 8.594.531.5c.476-.764.75-1.705.75-2.719v-28.625c0-1.294-.448-2.468-1.187-3.312zm-38.782 18.718l-7.812 7.594-8.875 8.594-1.125 1.094c.593.382 1.268.625 2 .625h51.719c.88 0 1.678-.338 2.344-.875l-.562-.562-8.875-8.594-8.156-7.875-7.344 7.562c-.397.264-.663.556-1.051.735-.625.289-1.309.533-1.997.523-.69-.011-1.367-.281-1.986-.585-.311-.153-.477-.305-.841-.61l-7.439-7.626z"
                    fill="#fff"
                  />
                </g>
              </svg>
              <svg
                v-if="row.item._provider == 'ip_address'"
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="29"
                viewBox="1 1 600 600"
              >
                <g transform="matrix(6.66667 0 0 6.66667 -5.667 -6408.081)">
                  <linearGradient
                    id="a"
                    gradientUnits="userSpaceOnUse"
                    x1="-110.934"
                    y1="1129.751"
                    x2="-110.35"
                    y2="1720.099"
                    gradientTransform="matrix(1 0 0 -1 156.89 2180.75)"
                  >
                    <stop offset="0" stop-color="#70efff" />
                    <stop offset="1" stop-color="#5770ff" />
                  </linearGradient>
                  <path
                    d="M21.653 961.362h48.695a20.608 20.608 0 0 1 20.653 20.653v48.695a20.608 20.608 0 0 1-20.653 20.653H21.653A20.608 20.608 0 0 1 1 1030.71v-48.695a20.608 20.608 0 0 1 20.653-20.653z"
                    fill="url(#a)"
                  />
                  <path
                    d="M20.719 986.956c-.474 0-.921.082-1.344.25l8.469 8.719 8.563 8.875.156.188.25.25.25.25.5.531 7.344 7.531c.122.076.477.404.754.543.357.178.743.343 1.141.357.43.015.869-.108 1.256-.296.29-.141.419-.343.755-.603l8.5-8.781 8.594-8.844 8.281-8.531a3.635 3.635 0 0 0-1.75-.438H20.719zm-2.594 1.062c-.903.856-1.469 2.142-1.469 3.594v28.625c0 1.175.377 2.243 1 3.062l1.187-1.125 8.844-8.594 7.844-7.594-.156-.187-8.594-8.844-8.594-8.875-.062-.062zm57.188.282l-8.375 8.656-8.563 8.844-.156.156 8.156 7.906 8.844 8.594.531.5c.476-.764.75-1.705.75-2.719v-28.625c0-1.294-.448-2.468-1.187-3.312zm-38.782 18.718l-7.812 7.594-8.875 8.594-1.125 1.094c.593.382 1.268.625 2 .625h51.719c.88 0 1.678-.338 2.344-.875l-.562-.562-8.875-8.594-8.156-7.875-7.344 7.562c-.397.264-.663.556-1.051.735-.625.289-1.309.533-1.997.523-.69-.011-1.367-.281-1.986-.585-.311-.153-.477-.305-.841-.61l-7.439-7.626z"
                    fill="#fff"
                  />
                </g>
              </svg>
              <svg
                v-if="row.item._provider == '_created_at'"
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="29"
                viewBox="1 1 600 600"
              >
                <g transform="matrix(6.66667 0 0 6.66667 -5.667 -6408.081)">
                  <linearGradient
                    id="a"
                    gradientUnits="userSpaceOnUse"
                    x1="-110.934"
                    y1="1129.751"
                    x2="-110.35"
                    y2="1720.099"
                    gradientTransform="matrix(1 0 0 -1 156.89 2180.75)"
                  >
                    <stop offset="0" stop-color="#70efff" />
                    <stop offset="1" stop-color="#5770ff" />
                  </linearGradient>
                  <path
                    d="M21.653 961.362h48.695a20.608 20.608 0 0 1 20.653 20.653v48.695a20.608 20.608 0 0 1-20.653 20.653H21.653A20.608 20.608 0 0 1 1 1030.71v-48.695a20.608 20.608 0 0 1 20.653-20.653z"
                    fill="url(#a)"
                  />
                  <path
                    d="M20.719 986.956c-.474 0-.921.082-1.344.25l8.469 8.719 8.563 8.875.156.188.25.25.25.25.5.531 7.344 7.531c.122.076.477.404.754.543.357.178.743.343 1.141.357.43.015.869-.108 1.256-.296.29-.141.419-.343.755-.603l8.5-8.781 8.594-8.844 8.281-8.531a3.635 3.635 0 0 0-1.75-.438H20.719zm-2.594 1.062c-.903.856-1.469 2.142-1.469 3.594v28.625c0 1.175.377 2.243 1 3.062l1.187-1.125 8.844-8.594 7.844-7.594-.156-.187-8.594-8.844-8.594-8.875-.062-.062zm57.188.282l-8.375 8.656-8.563 8.844-.156.156 8.156 7.906 8.844 8.594.531.5c.476-.764.75-1.705.75-2.719v-28.625c0-1.294-.448-2.468-1.187-3.312zm-38.782 18.718l-7.812 7.594-8.875 8.594-1.125 1.094c.593.382 1.268.625 2 .625h51.719c.88 0 1.678-.338 2.344-.875l-.562-.562-8.875-8.594-8.156-7.875-7.344 7.562c-.397.264-.663.556-1.051.735-.625.289-1.309.533-1.997.523-.69-.011-1.367-.281-1.986-.585-.311-.153-.477-.305-.841-.61l-7.439-7.626z"
                    fill="#fff"
                  />
                </g>
              </svg>
            </template>
            <!-- <template #cell(actions)="row">
              <div class="actions">
                <b-link size="sm" class="mt-2">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.66667 3.33333C2.48986 3.33333 2.32029 3.40357 2.19527 3.5286C2.07024 3.65362 2.00001 3.82319 2.00001 4V13.3333C2.00001 13.5101 2.07024 13.6797 2.19527 13.8047C2.32029 13.9298 2.48986 14 2.66667 14H12C12.1768 14 12.3464 13.9298 12.4714 13.8047C12.5964 13.6797 12.6667 13.5101 12.6667 13.3333V9.77333C12.6667 9.40514 12.9651 9.10667 13.3333 9.10667C13.7015 9.10667 14 9.40514 14 9.77333V13.3333C14 13.8638 13.7893 14.3725 13.4142 14.7475C13.0391 15.1226 12.5304 15.3333 12 15.3333H2.66667C2.13624 15.3333 1.62753 15.1226 1.25246 14.7475C0.877385 14.3725 0.666672 13.8638 0.666672 13.3333V4C0.666672 3.46957 0.877385 2.96086 1.25246 2.58579C1.62753 2.21071 2.13624 2 2.66667 2H6.22667C6.59486 2 6.89334 2.29848 6.89334 2.66667C6.89334 3.03486 6.59486 3.33333 6.22667 3.33333H2.66667Z"
                      fill="#B3C2CB"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.5286 0.862254C11.7889 0.601905 12.2111 0.601905 12.4714 0.862254L15.1381 3.52892C15.3984 3.78927 15.3984 4.21138 15.1381 4.47173L8.47141 11.1384C8.34639 11.2634 8.17682 11.3337 8 11.3337H5.33334C4.96515 11.3337 4.66667 11.0352 4.66667 10.667V8.00033C4.66667 7.82351 4.73691 7.65394 4.86193 7.52892L11.5286 0.862254ZM6.00001 8.27647V10.0003H7.72386L13.7239 4.00033L12 2.27647L6.00001 8.27647Z"
                      fill="#B3C2CB"
                    />
                  </svg>
                </b-link>
                <b-link size="sm" class="ml-1 mt-2">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 20C9.6193 20.0008 10.2235 19.8086 10.7285 19.4502C11.2335 19.0917 11.6143 18.5849 11.818 18H6.182C6.38566 18.5849 6.76648 19.0917 7.27151 19.4502C7.77654 19.8086 8.3807 20.0008 9 20ZM16 12.586V8C16 4.783 13.815 2.073 10.855 1.258C10.562 0.52 9.846 0 9 0C8.154 0 7.438 0.52 7.145 1.258C4.185 2.074 2 4.783 2 8V12.586L0.293001 14.293C0.199958 14.3857 0.126171 14.4959 0.0758854 14.6172C0.0256001 14.7386 -0.000189449 14.8687 1.04767e-06 15V16C1.04767e-06 16.2652 0.105358 16.5196 0.292894 16.7071C0.480431 16.8946 0.734785 17 1 17H17C17.2652 17 17.5196 16.8946 17.7071 16.7071C17.8946 16.5196 18 16.2652 18 16V15C18.0002 14.8687 17.9744 14.7386 17.9241 14.6172C17.8738 14.4959 17.8 14.3857 17.707 14.293L16 12.586Z"
                      fill="#B3C2CB"
                    />
                  </svg>
                </b-link>
                <b-btn
                  v-if="row.item._beta"
                  variant="outline-primary"
                  class="ml-1 mt-2"
                  size="sm"
                  disabled="disabled"
                >
                  Approved
                </b-btn>
                <b-btn
                  v-else
                  variant="outline-primary"
                  :id="row.item.userRef"
                  class="ml-1 mt-2"
                  size="sm"
                >
                  {{ btnText }}
                </b-btn>
              </div>
            </template> -->
          </b-table>
        </b-card>
        <b-pagination
          v-model="currentPage"
          :total-rows="allBetaUsers.length"
          :per-page="perPage"
          align="left"
          size="sm"
          class="my-0"
          aria-controls="beta_users"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      searchStr: "",
      btnText: "Approve",
      transProps: {
        name: "flip-list" // Transition name
      },
      fields: [
        { key: "email", sortable: true, label: "Email" },
        { key: "ip_address", sortable: true, label: "IP Address " },
        {
          key: "_created_at",
          sortable: true,
          label: "Submitted",
          formatter: "formatDate"
        }
        // { key: "actions", label: "Actions" }
        //     { key: "show_details", label: "Show Details" }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
      selectedUser: {},
      showUserNotify: true
    };
  },
  computed: {
    ...mapGetters({
      allBetaUsers: "admin/betaUsers"
    }),
    users() {
      if (this.searchStr.trim() == "") return this.allBetaUsers;
      let filteredUsers = [];
      let users = [];

      filteredUsers = this.allBetaUsers.filter(user => {
        return (
          user.firstname
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim()) ||
          user.lastname
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim())
        );
      });

      return users;
    }
  },
  mounted() { },
  methods: {
    handleActivation() {
      //lazy load only on selection. Prevent unecessary pulls and other benefits
      this.getBetaUsers();
    },
    getBetaUsers(){
      this.$store.dispatch("admin/getBetaUsers").then((res)=>{
        console.log(res);
      });
    },
    formatDate(date) {
      return date
        ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
        : "N/A";
    }
  }
};
</script>
<style lang="scss" scoped>
.card-guide {
  box-shadow: none;
}
</style>
